import { apiGetPDF } from './api-utils';

export const getOrderCenterForm = async (url: string): Promise<Response> => {
    const result = await apiGetPDF(url);

    return result;
};
